export const faqData = [
    {
        title:"What happens if I add more team members to my plan?",
        desc:"Additional team members can be added or removed at any time. The cost of each new team member will be pro-rated and charged based on the billing schedule you've selected (monthly or yearly)."
    },
    {
        title:"How are Team Members and Contributors different?",
        desc:"Team Members have access to all projects within your HostDesign account (great for employees). There is a per user charge for Team Members. Contributors can only see projects they have been specifically invited to (Great for freelancers). Contributors are included with your plan."
    },
    {
        title:"Can I cancel or switch at any time?",
        desc:"Yes! You can manage your plan 24/7 in your account section. Any downgrades are immediate and we do not offer refunds for unused time on your monthly or yearly plan."
    },
    {
        title:"What payment methods does HostDesign accept?",
        desc:"We accept Visa, Mastercard and American Express. Our Enterprise plan allows you to pay by invoice or bank transfer."
    },
    {
        title:"Do you have discounts for students and non-profits?",
        desc:"Yes! Up to 70%! In both cases, we require some additional verification information. Read more here."
    },
    {
        title:"How do I purchase more than 6 team members?",
        desc:"Our Enterprise plan has no limit on team members. Speak to the team for a demo and quote based on your needs."
    },
    {
        title:"Does HostDesign have any time-limits or trials?",
        desc:"Our free plan has no time-limits so you can use HostDesign for as long as you need before deciding to upgrade."
    },
    {
        title:"How secure is HostDesign?",
        desc:"Our free plan has no time-limits so you can use HostDesign for as long as you need before deciding to Read"
    }
]
